import React, { createContext } from 'react'

import type { CategoryBrandingContentBlock, MenuContentBlock } from '@library/api-menu-experience'

type MenuBranding = {
  backgroundColor?: string
  backgroundImageUrl?: string
  textColor?: string
}

export const MenuBrandingContext = createContext<MenuBranding>({})

type MenuBrandingProviderProps = React.PropsWithChildren<{
  value: MenuBranding
}>

export const MenuBrandingProvider = ({ children, value }: MenuBrandingProviderProps) => (
  <MenuBrandingContext.Provider value={value}>{children}</MenuBrandingContext.Provider>
)

type MenuBrandingContentBlock = CategoryBrandingContentBlock

const isMenuBrandingContentBlock = (
  contentBlock: MenuContentBlock,
): contentBlock is MenuBrandingContentBlock => contentBlock.type === 'category-branding'

const getBackgroundImageUrl = (contentBlock: MenuBrandingContentBlock) => {
  const sortedCrops = contentBlock.backgroundImage.crops.slice().sort((a, b) => b.width - a.width)
  const midpointInArray = Math.floor(sortedCrops.length / 2)

  return sortedCrops[midpointInArray]?.url
}

export const getMenuBranding = (contentBlocks: MenuContentBlock[]): MenuBranding => {
  const menuBrandingContentBlock = contentBlocks.find(isMenuBrandingContentBlock)

  if (!menuBrandingContentBlock) {
    return {}
  }

  return {
    backgroundColor: menuBrandingContentBlock.backgroundColor,
    backgroundImageUrl: getBackgroundImageUrl(menuBrandingContentBlock),
    textColor: menuBrandingContentBlock.textColor,
  }
}
